// Country code to language mapping
// Maps ALL countries to the most appropriate supported language
const COUNTRY_TO_LANGUAGE: Record<string, string> = {
  // === NATIVE LANGUAGE SPEAKERS ===
  
  // English-speaking countries
  US: 'en', GB: 'en', AU: 'en', CA: 'en', NZ: 'en', IE: 'en', JM: 'en', TT: 'en', BB: 'en', BS: 'en', GY: 'en', BZ: 'en',
  
  // Spanish-speaking countries
  ES: 'es', MX: 'es', AR: 'es', CO: 'es', CL: 'es', PE: 'es', VE: 'es', EC: 'es', GT: 'es', CU: 'es', 
  BO: 'es', DO: 'es', HN: 'es', PY: 'es', SV: 'es', NI: 'es', CR: 'es', PA: 'es', UY: 'es', PR: 'es', GQ: 'es',
  
  // French-speaking countries
  FR: 'fr', BE: 'fr', CH: 'fr', MC: 'fr', LU: 'fr', SN: 'fr', CI: 'fr', ML: 'fr', BF: 'fr', NE: 'fr', 
  TG: 'fr', BJ: 'fr', MG: 'fr', CM: 'fr', CD: 'fr', GA: 'fr', CG: 'fr', HT: 'fr', RW: 'fr', BI: 'fr',
  
  // German-speaking countries
  DE: 'de', AT: 'de', LI: 'de',
  
  // Italian-speaking countries
  IT: 'it', SM: 'it', VA: 'it',
  
  // Portuguese-speaking countries
  PT: 'pt', BR: 'pt', AO: 'pt', MZ: 'pt', CV: 'pt', GW: 'pt', ST: 'pt', TL: 'pt',
  
  // Japanese
  JP: 'ja',
  
  // Chinese-speaking countries/regions
  CN: 'zh', TW: 'zh', HK: 'zh', MO: 'zh',
  
  // Russian-speaking countries
  RU: 'ru', BY: 'ru', KZ: 'ru', KG: 'ru', TJ: 'ru', UZ: 'ru', TM: 'ru',
  
  // Arabic-speaking countries
  SA: 'ar', AE: 'ar', EG: 'ar', MA: 'ar', DZ: 'ar', IQ: 'ar', SD: 'ar', SY: 'ar', YE: 'ar', 
  TN: 'ar', JO: 'ar', LY: 'ar', LB: 'ar', OM: 'ar', KW: 'ar', QA: 'ar', BH: 'ar', PS: 'ar', MR: 'ar',
  
  // Turkish-speaking countries
  TR: 'tr', AZ: 'tr',  // Azerbaijan has similar Turkic language
  
  // Hindi-speaking (India)
  IN: 'hi',
  
  // Bengali-speaking (Bangladesh)
  BD: 'bn',
  
  // Urdu-speaking (Pakistan)
  PK: 'ur',
  
  // === COUNTRIES MAPPED TO MOST POPULAR/USEFUL LANGUAGE ===
  
  // Southeast Asia → English (widely used for business/tourism)
  SG: 'en', PH: 'en', MY: 'en', TH: 'en', VN: 'en', ID: 'en', MM: 'en', KH: 'en', LA: 'en', BN: 'en',
  
  // East Asia → English (international communication)
  KR: 'en',  // South Korea - English widely taught
  MN: 'ru',  // Mongolia - Russian influence
  
  // South Asia (non-Hindi/Bengali/Urdu)
  LK: 'en',  // Sri Lanka - English official
  NP: 'en',  // Nepal - English common
  BT: 'en',  // Bhutan - English official
  MV: 'en',  // Maldives - English widely used
  AF: 'ur',  // Afghanistan - Pashto/Dari similar to Urdu
  
  // Middle East (non-Arabic)
  IR: 'ar',  // Iran - Arabic script, cultural ties
  IL: 'en',  // Israel - English widely spoken
  
  // Europe (countries without native language in our list)
  NL: 'en',  // Netherlands - excellent English
  SE: 'en',  // Sweden - excellent English
  NO: 'en',  // Norway - excellent English
  DK: 'en',  // Denmark - excellent English
  FI: 'en',  // Finland - good English
  IS: 'en',  // Iceland - good English
  PL: 'en',  // Poland - English growing
  CZ: 'en',  // Czech Republic - English common
  SK: 'en',  // Slovakia - English common
  HU: 'en',  // Hungary - English common
  RO: 'en',  // Romania - English common
  BG: 'ru',  // Bulgaria - Russian influence
  GR: 'en',  // Greece - English for tourism
  HR: 'en',  // Croatia - English for tourism
  SI: 'en',  // Slovenia - English common
  RS: 'en',  // Serbia - English common
  BA: 'en',  // Bosnia - English common
  ME: 'en',  // Montenegro - English common
  MK: 'en',  // North Macedonia - English common
  AL: 'en',  // Albania - English growing
  XK: 'en',  // Kosovo - English common
  UA: 'ru',  // Ukraine - Russian widely understood
  MD: 'ru',  // Moldova - Russian common
  GE: 'ru',  // Georgia - Russian still used
  AM: 'ru',  // Armenia - Russian common
  LV: 'ru',  // Latvia - Russian minority
  LT: 'en',  // Lithuania - English growing
  EE: 'en',  // Estonia - English common
  MT: 'en',  // Malta - English official
  CY: 'en',  // Cyprus - English official (Greek Cypriot side)
  
  // Africa (countries without native language)
  ZA: 'en',  // South Africa - English official
  NG: 'en',  // Nigeria - English official
  KE: 'en',  // Kenya - English official
  GH: 'en',  // Ghana - English official
  TZ: 'en',  // Tanzania - English official
  UG: 'en',  // Uganda - English official
  ZW: 'en',  // Zimbabwe - English official
  ZM: 'en',  // Zambia - English official
  BW: 'en',  // Botswana - English official
  NA: 'en',  // Namibia - English official
  MW: 'en',  // Malawi - English official
  LS: 'en',  // Lesotho - English official
  SZ: 'en',  // Eswatini - English official
  MU: 'en',  // Mauritius - English official
  SC: 'en',  // Seychelles - English official
  ET: 'en',  // Ethiopia - English for education
  SO: 'ar',  // Somalia - Arabic influence
  DJ: 'fr',  // Djibouti - French official
  ER: 'ar',  // Eritrea - Arabic official
  SS: 'en',  // South Sudan - English official
  CF: 'fr',  // Central African Republic - French
  TD: 'fr',  // Chad - French official
  GN: 'fr',  // Guinea - French
  SL: 'en',  // Sierra Leone - English
  LR: 'en',  // Liberia - English
  GM: 'en',  // Gambia - English
  
  // Caribbean & Central America
  SR: 'en',  // Suriname - Dutch but English understood
  
  // Pacific Islands
  FJ: 'en',  // Fiji - English official
  PG: 'en',  // Papua New Guinea - English
  WS: 'en',  // Samoa - English
  TO: 'en',  // Tonga - English
  VU: 'en',  // Vanuatu - English
  SB: 'en',  // Solomon Islands - English
  NC: 'fr',  // New Caledonia - French
  PF: 'fr',  // French Polynesia - French
  GU: 'en',  // Guam - English
};

// Supported languages in our app
const SUPPORTED_LANGUAGES = ['en', 'es', 'fr', 'de', 'it', 'pt', 'ja', 'zh', 'ru', 'ar', 'tr', 'hi', 'bn', 'ur'];

interface GeoLocationResponse {
  country_code?: string;
  countryCode?: string;
  country?: string;
}

/**
 * Detect user's country from IP address using free geolocation API
 */
export async function detectCountryFromIP(): Promise<string | null> {
  try {
    // Try ip-api.com first (free, no API key needed, 45 requests/minute)
    const response = await fetch('http://ip-api.com/json/?fields=countryCode', {
      method: 'GET',
      signal: AbortSignal.timeout(3000), // 3 second timeout
    });
    
    if (response.ok) {
      const data: GeoLocationResponse = await response.json();
      return data.countryCode || null;
    }
  } catch {
    // If ip-api fails, try ipapi.co as fallback
    try {
      const response = await fetch('https://ipapi.co/json/', {
        method: 'GET',
        signal: AbortSignal.timeout(3000),
      });
      
      if (response.ok) {
        const data: GeoLocationResponse = await response.json();
        return data.country_code || null;
      }
    } catch {
      // Both APIs failed
      console.warn('Could not detect country from IP');
    }
  }
  
  return null;
}

/**
 * Get language code from country code
 * Falls back to English for unlisted countries (most widely understood globally)
 */
export function getLanguageFromCountry(countryCode: string): string {
  const language = COUNTRY_TO_LANGUAGE[countryCode.toUpperCase()];
  
  // Return mapped language if it's supported
  if (language && SUPPORTED_LANGUAGES.includes(language)) {
    return language;
  }
  
  // Default to English for any unlisted country
  return 'en';
}

/**
 * Storage key for geo-detected language
 */
export const GEO_LANGUAGE_KEY = 'geo_language_detected';

/**
 * Check if geo detection has already been done
 */
export function hasGeoLanguageBeenDetected(): boolean {
  return localStorage.getItem(GEO_LANGUAGE_KEY) === 'true';
}

/**
 * Mark geo detection as complete
 */
export function markGeoLanguageDetected(): void {
  localStorage.setItem(GEO_LANGUAGE_KEY, 'true');
}

/**
 * Auto-detect and set language based on user's IP location
 * Only runs once per browser (stores flag in localStorage)
 */
export async function autoDetectAndSetLanguage(
  changeLanguage: (lang: string) => void
): Promise<string | null> {
  // Skip if user has already manually selected a language
  const manuallySelected = localStorage.getItem('i18nextLng');
  if (manuallySelected && hasGeoLanguageBeenDetected()) {
    return manuallySelected;
  }

  // Skip if we've already done geo detection
  if (hasGeoLanguageBeenDetected()) {
    return null;
  }

  try {
    const countryCode = await detectCountryFromIP();
    
    if (countryCode) {
      const language = getLanguageFromCountry(countryCode);
      changeLanguage(language);
      markGeoLanguageDetected();
      console.log(`Auto-detected language: ${language} (from country: ${countryCode})`);
      return language;
    }
  } catch (error) {
    console.warn('Failed to auto-detect language:', error);
  }

  // Mark as detected even if we couldn't determine the language
  // This prevents repeated API calls on every page load
  markGeoLanguageDetected();
  return null;
}

